export default "__VITE_ASSET__f92cb582__"